export default "__VITE_ASSET__CxrJik9u__"